import { Component, ElementRef, Inject, QueryList, ViewChildren } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { filter } from 'rxjs';

export interface StandardDialogData {
    title: string;
    body: string;
	type: string;
	icon?: string;
    buttons?: Button[]
}

export class Button {
	name: string;
	type?: string;
	action?: string;

	constructor(name: string, action?: string, type = 'default') {
		this.name = name;
		this.type = type;
		this.action = action;
	}
}

@Component({
	templateUrl: "./standard-dialog.component.html"
})
export class StandardDialogComponent{
	@ViewChildren('dialogButton') private buttonEls!: QueryList<ElementRef<HTMLButtonElement>>;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: StandardDialogData,
		public dialogRef: MatDialogRef<StandardDialogComponent>
	){
		this.dialogRef.keydownEvents()
			.pipe(filter((e) => e.key === 'Enter' && !e.shiftKey && !e.ctrlKey && !e.metaKey && !e.altKey))
			.subscribe((e) => {
				const buttons = this.data.buttons;
				if (!buttons?.length) return;
				const primary = buttons.find((b) => b.type === 'primary') ?? buttons[buttons.length - 1];
				e.preventDefault();
				this.dialogRef.close(primary.action || primary.name);
			});

		this.dialogRef.keydownEvents()
			.pipe(filter((e) => ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)))
			.subscribe((e) => this.moveFocus(e));
	}

	// Cursor keys move focus between the footer buttons; the focused button
	// shows a frame via the :focus-visible style in m-modal.scss.
	private moveFocus(event: KeyboardEvent): void {
		const els = this.buttonEls?.map((b) => b.nativeElement) ?? [];
		if (els.length < 2) return;
		event.preventDefault();
		const step = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
		const current = els.indexOf(document.activeElement as HTMLButtonElement);
		const next = (current === -1 ? (step === 1 ? -1 : 0) : current) + step;
		els[(next + els.length) % els.length].focus();
	}
}
